module.exports = __webpack_public_path__ + "media/images/checkout/Google-safe-8a3133c447a654c4bd126a24e90b76fa.png";